import styled from 'styled-components';
import { AssistChipMixin } from '../../mixins/components/AssistChipMixin';
import { Button } from '../Button/Button';
export var StyledAssistChip = /*#__PURE__*/styled(Button).withConfig({
  displayName: "StyledAssistChip",
  componentId: "c11n-8-111-1__sc-1gr17jv-0"
})(["", ""], AssistChipMixin);